var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.geoscriptParsed.error)?_c('div',[_c('pre',{staticClass:"pre-wrap",domProps:{"innerHTML":_vm._s(_vm.geoscriptParsed.data)}})]):_c('div',{staticClass:"error--text"},[_vm._v(" "+_vm._s(_vm.geoscriptParsed.data)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }